/** Чистые части `RollingNumber`: разбор текста на колонки и сдвиг барабана. */

const DIGIT = /^[0-9]$/;

/** Сдвиг столбика 0–9 к своей цифре: столбик — десять строк, одна цифра — 10 % его высоты. */
export function digitShift(digit: number): string {
  return `translateY(-${digit * 10}%)`;
}

/**
 * С какой цифры колонка начинает: при первом показе числа — со своей, у
 * колонки, появившейся позже, — с нуля.
 */
export function startDigit(digit: number, scrollIn: boolean): number {
  return scrollIn ? 0 : digit;
}

export interface ColumnSpec {
  /** Позиция от правого края: единицы остаются той же колонкой при смене длины числа. */
  key: number;
  char: string;
  /** Цифра колонки или `null` для статичного символа. */
  digit: number | null;
  scrollIn: boolean;
}

/** Колонки текста слева направо; `scrollIn` — число уже показывалось, новые колонки прокручиваются от нуля. */
export function columnsOf(text: string, scrollIn: boolean): ColumnSpec[] {
  const chars = Array.from(text);
  return chars.map((char, index) => ({
    key: chars.length - 1 - index,
    char,
    digit: DIGIT.test(char) ? Number(char) : null,
    scrollIn,
  }));
}
